import api from 'api/api'
import useStore from 'state/knovStore'

// The space member list (GET /api/v1/users) is large — every member, unpaginated,
// about 1.75MB in the main space — so it is no longer fetched at boot. Components
// that need it (mentions, @handles, the filter icon, raffles) ask for it here, and
// concurrent callers share one request.
let inFlight: Promise<unknown[] | null> | null = null

export function ensureSpaceUsersLoaded(): Promise<unknown[] | null> {
    if (!window.gon?.currentUser) return Promise.resolve(null)

    const loaded = useStore.getState().users
    if (Array.isArray(loaded) && loaded.length > 0) return Promise.resolve(loaded)

    if (!inFlight) {
        inFlight = api
            .getUsers()
            .then(users => {
                useStore.getState().set({ users })
                return users
            })
            .catch(error => {
                console.error('[spaceUsers] Failed to load space users:', error)
                return null
            })
            .finally(() => {
                inFlight = null
            })
    }
    return inFlight
}
